import React from "react";
import { useLocation } from "react-router-dom";
import Banner from "../Components/Banner";
import { Helmet } from "react-helmet-async";

// Desktop Banner Images
import residential_image from '../images/residential/banner_image.png'
import apartment_banner from '../images/banner_images/laptop/apartments-banner-1.webp'
import Property from "../Components/Property";
import plots_banner from "../images/primary/plots_banner.jpg"
import villa_banner from '../images/primary/villas_banner.jpg'
import commercial_banner from "../images/banner_images/laptop/commercial_banner_image.jpg"

// Mobile Banner Images
import apartment_banner_mobile from '../images/banner_images/mobile/mobile-apartment-banner-01.webp'

function Primary_Filtered() {
    const { pathname } = useLocation();
    const url = pathname;

    let condition;
    let desktopImage;
    let mobileImage;
    let seoTitle ;
    let seoDescription;
    let keywords; 


    if (url === "/apartments-and-villas-for-sale-in-coimbatore") {
        condition = "apartment";
        desktopImage = apartment_banner;
        mobileImage = apartment_banner_mobile;
        seoTitle = "Apartments & Luxury Villas for Sale in Coimbatore";
        seoDescription = "Explore the best new and luxury apartments and villas for sale in prime locations across Coimbatore. Find your dream home with Lands & Lands";
        keywords = "apartments for sale in Coimbatore, villas for sale in Coimbatore, new apartments Coimbatore, luxury villas Coimbatore, residential properties Coimbatore, buy property in Coimbatore, houses for sale in Coimbatore, Lands & Lands"
    } 
    
    if (url === "/plots-for-sale-in-coimbatore") {
        condition = "plots"
        desktopImage = plots_banner
        mobileImage = plots_banner
    } 
    
    if (url === "/office-space-for-rent-in-coimbatore") {
        condition = "officespace";
        desktopImage = commercial_banner;
        mobileImage = commercial_banner;
        seoTitle = "Commercial Property for Rent in Coimbatore - Office, Reatil, Warehouse";
        seoDescription = "Find the best office space, retail shops, co-working spaces and warehouses for rent in prime Coimbatore locations. Start your business search with Lands & Lands";
        keywords = "office space for rent in Coimbatore, commercial property for rent Coimbatore, retails space for rent Coimbatore, shop for rent Coimbatore, warehouse for rent Coimbatore, co-working space Coimbatore, commercial real estate Coimbatore, Lands & Lands"
    } 
    
    if (url === "/buy-house-in-coimbatore") {
        condition = "resale"
        desktopImage = villa_banner
        mobileImage = villa_banner
    };


    return (
        <>
            <Helmet>
                <title>{seoTitle}</title>

                <meta name="description" content={seoDescription} />
                <meta name="keywords" content={keywords} />
            </Helmet>


            {/* <Banner 
                img = {desktopImage}
                mimg= {mobileImage}
                
            />    */}

            {/* Banner */}
            <div className="relative ">
                <img className="banner-image hidden md:block " src={desktopImage} alt="Property-banner" />

                {/* Mobile Banner*/}
                <img className="banner-image !w-full !h-auto !object-cover  block md:hidden " src={mobileImage} alt="Property-banner" />

            </div>

            <Property
                list={condition}

            />

        </>
    )
}

export default Primary_Filtered